import { Routes, Route } from 'react-router-dom';
import Header from './Header';
import Home from './Home';
import Menu from './Menu';
import Footer from './Footer';
import Register from './Register';
import ChangePassword from './ChangePassword';
import Login from './Login';

//Front Office
import FrontMenu from './FrontOffice/FrontMenu';
import CashLab from './FrontOffice/CashLab';
import FoLabEntry from './FrontOffice/FoLabEntry';
import LabEntry from './FrontOffice/LabEntry';
import FoInvEntry from './FrontOffice/FoInvEntry';
import InvEntry from './FrontOffice/InvEntry';
import CashInv from './FrontOffice/CashInv';
//Lab
import LabMenu from './Lab/LabMenu';
import LabView from './Lab/LabView';
import LabMachine from './Lab/LabMachine';
import LabResultEntry from './Lab/LabResultEntry';
import LabResultEntrySaved from './Lab/LabResultEntrySaved';
import LabResultView from './Lab/LabResultView';
import LabReportOp from './Lab/LabReportOp';
import LabReportOpAll from './Lab/LabReportOpAll';
import CollectionLab from './Lab/CollectionLab';
import LabPayment from './Lab/LabPayment';
import LabInvoiceOp from './Lab/LabInvoiceOp';
import CreateWO from './Lab/CreateWO';
import CreateSampleid from './Lab/CreateSampleid';
import AddCat from './Lab/AddCat';
import EditCat from './Lab/EditCat';
import AddSubCat from './Lab/AddSubCat';
import EditSubCat from './Lab/EditSubCat';
import AddTest from './Lab/AddTest';
import ViewTest from './Lab/ViewTest';
import EditTest from './Lab/EditTest';
import LabAllResultView from './Lab/LabAllResultView';
import OrderAccept from './Lab/OrderAccept';
import SampleCollect from './Lab/SampleCollect';
//Radiology
import AddRadio from './Radiology/AddRadio';
import EditRadio from './Radiology/EditRadio';
import InvMenu from './Radiology/InvMenu';
import InvView from './Radiology/InvView';
import InvResultEntry from './Radiology/InvResultEntry';
import InvResultView from './Radiology/InvResultView';
import InvFilesView from './Radiology/InvFilesView';
import CollectionInv from './Radiology/CollectionInv';
import InvPayment from './Radiology/InvPayment';
import InvInvoiceOp from './Radiology/InvInvoiceOp';
import DicomStart from './Radiology/DicomStart';
import DICOMViewer from './Radiology/DICOMViewer';
import DicomPage from "./Radiology/DicomPage";
//Patient
import PatientRegister from './Patient/PatientRegister';
import PatSearch from './Patient/PatSearch';
import EmrDetails from './Patient/EmrDetails';
import EditPatient from './Patient/EditPatient';
import PatPrint from './Patient/PatPrint';
import PatBillSearch from './Patient/PatBillSearch';
import PatBillDetails from './Patient/PatBillDetails';
//Other
import MasterMenu from './Other/MasterMenu';
import GenerateBarcode from './Other/GenerateBarcode';
import Support from './Other/Support';
import AddTemplate from './Other/AddTemplate';
import EditTemplate from './Other/EditTemplate';
import MisMenu from './Other/MisMenu';
import MisCollection from './Other/MisCollection';
import {AuthProvider} from '../context/AuthContext';
import PrivateRoute from './PrivateRoute';
import { useState } from 'react';


function Main() {
  return (
    <div className="App">
             <AuthProvider>
               <Header />
               <Routes>
                    <Route element={<PrivateRoute allowedRoles={['Admin']}/>}>
                        <Route path="/user-register" element={<Register />}  />
                        <Route path="/master-menu" element={<MasterMenu />} />
                        <Route path="/mis-menu" element={<MisMenu />} />
                         
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'FrontOffice']}/>}>
                        <Route path="/front-menu" element={<FrontMenu />} />
                       
                        //Patient
                        <Route path="/add-patient" element={<PatientRegister />} />
                        <Route path="/edit-patient/:patId" element={<EditPatient />} />

                       
                    </Route>
                    
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Lab', 'FrontOffice', 'Cashier', 'Radiology']}/>}>
                        <Route path="/cashier-lab" element={<CashLab />} />
                        <Route path="/cashier-inv" element={<CashInv />} />
                        <Route path="/lab-pay/:lab_id" element={<LabPayment />} />
                        <Route path="/lab-invoice-op/:sale_lab/" element={<LabInvoiceOp />} />
                        <Route path="/accept-order-lab/:lab_id/" element={<CreateWO />} />
                        <Route path="/create-sample-id/:lab_id/:ltestid/" element={<CreateSampleid />} />
                    </Route>                    
                    
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Cashier', 'FrontOffice']}/>}>
                        //Cashier
                            
                        <Route path="/inv-pay/:inv_id" element={<InvPayment />} />
                        <Route path="/inv-invoice-op/:sale_inv/" element={<InvInvoiceOp />} />
                        <Route path="/collection-inv" element={<CollectionInv />} />
                    
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Lab', 'FrontOffice']}/>}>
                        //Lab
                        <Route path="/lab-menu" element={<LabMenu />} />
                        <Route path="/add-cat" element={<AddCat />} />
                        <Route path="/edit-cat/:cat_id" element={<EditCat />} />
                        <Route path="/add-subcat" element={<AddSubCat />} />
                        <Route path="/edit-subcat/:subcat_id" element={<EditSubCat />} />
                        <Route path="/add-test" element={<AddTest />} />
                        <Route path="/view-test" element={<ViewTest />} />
                        <Route path="/edit-test/:test_id" element={<EditTest />} />
                        <Route path="/fo-lab-entry" element={<FoLabEntry />} />
                        <Route path="/lab-entry/:pat_id" element={<LabEntry />} />


                        <Route path="/lab-view" element={<LabView />} />
                        <Route path="/lab-machine" element={<LabMachine />} />
                        <Route path="/lab-result-view" element={<LabResultView />} />
                        <Route path="/lab-result-entry/:lab_id/:ltestid" element={<LabResultEntry />} />
                        <Route path="/lab-result-entry-saved/:lab_id/:ltestid" element={<LabResultEntrySaved />} />
                        <Route path="/lab-report-op/:id/" element={<LabReportOp />} />


                        <Route path="/lab-result-view-all" element={<LabAllResultView />} />

                        <Route path="/order-accept" element={<OrderAccept />} />
                        <Route path="/sample-collect" element={<SampleCollect />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Radiology', 'FrontOffice', 'Cashier']}/>}>
                    //Radiology
                        <Route path="/inv-view" element={<InvView />} />
                        <Route path="/inv-menu" element={<InvMenu />} />
                        <Route path="/add-radio" element={<AddRadio />} />
                        <Route path="/edit-components/:components_id" element={<EditRadio />} />
                        <Route path="/fo-inv-entry" element={<FoInvEntry />} />
                        <Route path="/inv-entry/:pat_id" element={<InvEntry />} />

                        <Route path="/inv-result-enter/:inv_id/:itest_id" element={<InvResultEntry />} />
                        <Route path="/inv-files-view" element={<InvResultView />} />
                        <Route path="/inv-images/:id" element={<InvFilesView />} />
                        <Route path="/start-dicom" element={<DicomStart />} />
                        <Route path="/view-dicom" element={<DICOMViewer />} />
                        <Route path="/dicom" element={<DicomPage />} />
                    </Route>
                    
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Lab', 'Consultant', 'Radiology', 'Ip', 'Nurse', 'FrontOffice', 'Cashier']}/>}>
                        <Route path="/lab-report-all/:lab_id/" element={<LabReportOpAll />} />
                        <Route path="/collection-lab" element={<CollectionLab />} />
                    </Route>
                    
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Lab', 'Radiology', 'Cashier', 'Consultant',
                        'Hr', 'Accounting', 'FrontOffice', 'Ip', 'Nurse', 'Pharmacy', 'PharmacyStore', 'Stores', 'Management', 'BloodBank']}/>}>
                        <Route path="/" element={<Home />}  exact />

                        <Route path="/change-password" element={<ChangePassword />}  />
                        <Route path="/admin-menu" element={<Menu />} />
                        <Route path="/pat-search" element={<PatSearch />} />
                        <Route path="/pat-bill-search" element={<PatBillSearch />} />
                        <Route path="/bill-details/:pat_id" element={<PatBillDetails />} />
                        <Route path="/emr-details/:pat_id" element={<EmrDetails />} />
                        <Route path="/pat-print/:pat_id" element={<PatPrint />} />
                        <Route path="/barcode" element={<GenerateBarcode />} />
                        <Route path="/support" element={<Support />} />
                        <Route path="/add-template" element={<AddTemplate />} />
                        <Route path="/edit-template/:id" element={<EditTemplate />} />
                        <Route path="/mis-collection" element={<MisCollection />} />
                    
                    </Route>
                    <Route path="/user-login" element={<Login />} />
               </Routes>
             </AuthProvider>
             <Footer />

    </div>
  );
}
export default Main;